module.exports = __webpack_public_path__ + "img/dropdown.eebf6718.svg";